/* ============================================================
   NUVIA REDESIGN 2026-05 · JS overlay
   - Pone aliases data-nv-anchor en las secciones target
   - Marca active link del nav según scroll position
   - Smooth scroll con offset para sticky header
   ============================================================ */

(function () {
  'use strict';

  /* Mapping: Shopify section ID → alias limpio para anchors del nav */
  var ANCHOR_MAP = {
    /* 2026-09-14 · La cabecera suelta `custom_liquid_lactHomeHero` quedó APAGADA: la sección de
       lactancia del home ahora es una sola (`custom_liquid_lactGrid`, nuvia-lact-grid.liquid). Si
       el ancla siguiera colgada de la apagada, el «Lactancia» del menú no saltaría a ningún lado. */
    'custom_liquid_lactGrid': 'lactancia',
    'nv_payment': 'pagos',
    'custom_liquid_8gRz9h': 'nosotros',
    'nv_mens_teaser': 'mens',
    /* 2026-08-12 · Las dos secciones del home a las que ahora apunta el menú.
       Los usa `blocks/_header-menu.liquid` (escritorio y barra del celular) y
       `snippets/header-drawer.liquid` (cajón), siempre con data-nv-target.
       ⚠️ SOLO EXISTEN EN EL HOME DE MUJER. Por eso los dos consumidores las
          pintan únicamente cuando `is_mens` es falso: desde /pages/mens el
          fallback de nvResolveTarget mandaría a `/pages/mens#...`, que no
          existe, y el clic moriría en una página sin ancla. */
    'nv_limited': 'edicion-limitada',
    'nv_womens_header': 'pijamas-mujer'
  };

  /* Resuelve el wrapper de una sección por su ID base, tolerando el prefijo que
     Shopify antepone cuando la sección vive en un template JSON, ej:
     shopify-section-template--22492530933985__custom_liquid_lactHomeHero.
     Por eso NO basta getElementById('shopify-section-'+id): matcheamos el sufijo __id. */
  function findSection(sectionId) {
    return document.getElementById('shopify-section-' + sectionId)
        || document.querySelector('[id^="shopify-section-"][id$="__' + sectionId + '"]');
  }

  function tagAnchorSections() {
    Object.keys(ANCHOR_MAP).forEach(function (sectionId) {
      var alias = ANCHOR_MAP[sectionId];
      var el = findSection(sectionId);
      if (el) {
        el.setAttribute('data-nv-anchor', alias);
        // También agrego id alias para que href="#lactancia" funcione directo
        if (!document.getElementById(alias)) {
          el.id = el.id; // mantener original
          var marker = document.createElement('span');
          marker.id = alias;
          marker.setAttribute('aria-hidden', 'true');
          marker.style.cssText = 'position:absolute;top:-110px;left:0;width:0;height:0;overflow:hidden;';
          el.style.position = el.style.position || 'relative';
          el.insertBefore(marker, el.firstChild);
        }
      }
    });
  }

  /* Active link tracking */
  function setupActiveLinkTracking() {
    var navLinks = document.querySelectorAll('.nv-anchor-menu a[data-nv-target]');
    if (!navLinks.length) return;

    var sections = [];
    navLinks.forEach(function (link) {
      var target = link.getAttribute('data-nv-target');
      if (!target) return;
      if (target === 'top') {
        sections.push({ link: link, el: document.body, target: 'top' });
      } else {
        var el = document.getElementById(target);
        if (el) sections.push({ link: link, el: el, target: target });
      }
    });

    function updateActive() {
      var scrollY = window.scrollY;
      var triggerOffset = 140;
      var activeIdx = 0;

      sections.forEach(function (s, i) {
        if (s.target === 'top') return;
        var rect = s.el.getBoundingClientRect();
        var top = rect.top + scrollY;
        if (scrollY + triggerOffset >= top) activeIdx = i;
      });

      sections.forEach(function (s, i) {
        if (i === activeIdx && scrollY > 50) {
          s.link.classList.add('is-active');
        } else {
          s.link.classList.remove('is-active');
        }
      });
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          updateActive();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    updateActive();
  }

  /* Base "home" del universo actual: Mujer = "/", Hombre = "/pages/mens" */
  function nvHomePath() {
    return window.location.pathname.indexOf('/pages/mens') === 0 ? '/pages/mens' : '/';
  }
  function nvOnHome() {
    var h = nvHomePath();
    return window.location.pathname === h || window.location.pathname === h + '/';
  }

  /* Resuelve el alias (data-nv-target) a la sección real en la página ACTUAL. */
  function nvResolveTarget(target) {
    var el = null;
    Object.keys(ANCHOR_MAP).forEach(function (sid) {
      if (ANCHOR_MAP[sid] === target) el = findSection(sid);
    });
    if (!el) el = document.getElementById(target);
    return el;
  }

  /* Smooth scroll click handler con offset — captura cualquier [data-nv-target].
     Si la sección NO existe en esta página (ej. estamos en una colección/PDP),
     navega al home del universo + ancla para que allá se haga el scroll.
     Antes: hacía preventDefault y el link quedaba muerto fuera del home. */
  /* Cierra el cajón del celular (y cualquier modal con bloqueo de scroll) antes
     de hacer scroll.

     2026-08-12 · Eusso: «cuando ya den click se debe cerrar el menú y llevarte a
     la sección, el menú se queda abierto». Eran DOS problemas encadenados:

     1. El manejador de abajo hace preventDefault + stopPropagation, así que el
        clic nunca llegaba al componente del cajón y este no se enteraba de que
        había que cerrarse. Con un enlace normal el cajón se cierra porque la
        página navega; con un ancla no navega nada.
     2. Aunque se cerrara, el scroll NO se podía mover: mientras el cajón está
        abierto, `assets/dialog.js` le pone `scroll-lock` al <html> y
        `assets/base.css:44` lo traduce en `overflow:hidden`. Por eso hay que
        cerrar PRIMERO y hacer scroll DESPUÉS.

     Se cierra poniendo `open = false` en el <details>, no tocando el atributo
     `scroll-lock` a mano: así lo hace el propio dialog.js al escuchar el evento
     `toggle` y no se desincroniza si hubiera otro modal abierto. */
  function nvCerrarCajones() {
    var abiertos = document.querySelectorAll('details[scroll-lock][open]');
    if (!abiertos.length) return false;
    Array.prototype.forEach.call(abiertos, function (d) {
      d.open = false;
      /* 24-oct · QA Q10: el cajón se cerraba pero el ícono quedaba en ✕. El ícono lo
         decide la clase `menu-open` del <details> y `aria-expanded` del <summary>, que
         solo limpia el propio header-drawer.js al cerrar por su botón. Se limpian igual
         que en su `reset()` para que vuelva a ☰. */
      d.classList.remove('menu-open');
      var s = d.querySelector('summary');
      if (s) s.setAttribute('aria-expanded', 'false');
      var panel = d.querySelector('.menu-drawer');
      if (panel) panel.classList.remove('menu-drawer--has-submenu-opened');
    });
    return true;
  }

  /* El evento `toggle` del <details> es asíncrono, y recién ahí dialog.js quita
     el bloqueo. Por eso, si se cerró algo, el scroll se difiere. El rect se mide
     DENTRO de la función diferida: medirlo antes daría la posición de cuando el
     scroll todavía estaba bloqueado. */
  /* Cuánto dejar libre arriba al aterrizar en una sección.

     Antes era 100px fijos. Con el header ya fijo (12-ago) eso dejaba asomando la
     cola de la sección anterior: el header mide 49px y sobraban ~50px de la
     sección de arriba. Ahora se lee la altura real del header, que el propio
     theme publica en `--header-height` sobre el <body>, y se le suma un respiro
     chico. Si algún día el header cambia de alto, esto se ajusta solo.
     El 56 es el plan B por si la variable no estuviera. */
  function nvOffsetTop() {
    var v = getComputedStyle(document.body).getPropertyValue('--header-height');
    var h = parseInt(v, 10);
    if (!h || isNaN(h)) h = 56;
    return h + 14;
  }

  function nvScrollA(el, target) {
    var ir = function () {
      var top = el.getBoundingClientRect().top + window.scrollY - nvOffsetTop();
      window.scrollTo({ top: top, behavior: 'smooth' });
      if (target && history.replaceState) history.replaceState(null, '', '#' + target);
    };
    if (nvCerrarCajones()) {
      setTimeout(ir, 60);
    } else {
      ir();
    }
  }

  function setupSmoothScroll() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[data-nv-target]');
      if (!link) return;
      var target = link.getAttribute('data-nv-target');

      if (target === 'top') {
        e.preventDefault();
        e.stopPropagation();
        if (nvOnHome()) {
          var subir = function () {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            if (history.replaceState) history.replaceState(null, '', window.location.pathname);
          };
          if (nvCerrarCajones()) setTimeout(subir, 60); else subir();
        } else {
          window.location.href = nvHomePath();
        }
        return;
      }

      var el = nvResolveTarget(target);

      /* No está en esta página → ir al home del universo + ancla.
         Acá no hace falta cerrar nada: la navegación se lleva el cajón. */
      if (!el) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = nvHomePath() + '#' + target;
        return;
      }

      e.preventDefault();
      e.stopPropagation();
      nvScrollA(el, target);
    });
  }

  /* Al aterrizar en el home con #ancla (viniendo de otra página), hacer scroll
     con el offset del header. El marker lo crea tagAnchorSections, así que el
     scroll nativo del navegador puede no encontrarlo a tiempo. */
  function scrollToHashOnLoad() {
    var hash = (window.location.hash || '').replace(/^#/, '');
    if (!hash) return;
    var el = nvResolveTarget(hash);
    if (!el) return;
    setTimeout(function () {
      var rect = el.getBoundingClientRect();
      var top = rect.top + window.scrollY - nvOffsetTop();
      window.scrollTo({ top: top, behavior: 'smooth' });
    }, 80);
  }

  /* Inyecta:
     - Switch compacto cobalt/morado (mobile only, position fixed)
     - Toggle píldora Mujer|Hombre completa (desktop only, position fixed)
     Ambos en <body> con position:fixed para evitar conflictos con el grid del header */
  function injectMobileUniverseSwitch() {
    if (document.querySelector('.nv-header-switch')) return;

    var isMens = window.location.pathname.indexOf('/pages/mens') === 0
              || window.location.pathname.indexOf('/pages/hombre') === 0
              || document.body.classList.contains('nv-universe-mens');

    /* ----- Switch compacto mobile ----- */
    var label = isMens ? 'Mujer' : 'Hombre';
    var href  = isMens ? '/' : '/pages/mens';

    var a = document.createElement('a');
    a.href = href;
    a.className = 'nv-header-switch';
    a.setAttribute('aria-label', 'Cambiar a ' + label);
    var labelSpan = document.createElement('span');
    labelSpan.className = 'nv-header-switch-label';
    labelSpan.textContent = label;
    var arrowSpan = document.createElement('span');
    arrowSpan.className = 'nv-header-switch-arrow';
    arrowSpan.setAttribute('aria-hidden', 'true');
    arrowSpan.textContent = '→';
    a.appendChild(labelSpan);
    a.appendChild(arrowSpan);

    /* ----- NUVIA 2026-08-03 (header v7): el toggle Mujer|Hombre de DESKTOP se eliminó -----
       Existía como píldora morada al lado del carrito. Desde que el menú del header pasó
       a categorías reales, la entrada "Hombre" del menú hace exactamente lo mismo, así que
       el toggle repetía la misma acción a dos centímetros de distancia — y era el único
       elemento con fondo sólido del header, o sea que se llevaba la mirada siendo lo menos
       importante. Se probó moverlo a la columna izquierda en texto y el dueño igual pidió
       sacarlo ("quita ese botón", 03-ago, sobre la vista previa).

       Ir a Hombre en desktop es ahora el menú. En Hombre, volver a Mujer es la entrada
       "Mujer" del mismo menú (y el logo, que respeta el universo — ver _header-logo.liquid).

       El switch de CELULAR (.nv-header-switch, la variable `a` de arriba) SE QUEDA: en
       celular manda el cajón hamburguesa y este chip es el acceso rápido de una mano.
       Si algún día se quiere el toggle de desktop de vuelta, el CSS .nv-header-toggle-desktop
       y .nv-toggle siguen en redesign-2026.css — solo falta volver a crear el nodo acá. */
    /* ----- Píldora Mujer|Hombre para ESCRITORIO (13-ago) -----
       Eusso la dibujó sobre una captura: en el hueco a la izquierda de la cuenta
       y el carrito, arriba a la derecha. Va acá y no dentro de la lista del menú
       porque el 12-ago se probó allá y le robó tanto ancho que «Ofertas» (con su
       chapita NUEVO) se cayó dentro de un menú «Más» a 1280px. En la zona de
       acciones no compite con ninguna entrada.

       Las dos piezas conviven y se turnan por ancho de pantalla:
       · celular  → `.nv-header-switch`, el chip único de siempre. Eusso: «lo más
                    similar a lo que tenemos hoy está bastante ok para celular».
                    Ya se esconde solo en escritorio, por `redesign-2026.css`.
       · escritorio → esta píldora. Se esconde en celular con la regla
                    `.nv-toggle-wrap--desk` del `{% stylesheet %}` de
                    `blocks/_header-menu.liquid`, donde también se le baja el
                    margen: `.nv-toggle-wrap` trae 18px pensados para cuando vivía
                    dentro del menú.

       ⚠️ En Hombre el menú del header queda vacío (sus categorías eran todas de
          mujer). La píldora es lo único que sobrevive ahí, y sale de acá: no hay
          una segunda copia en el marcado. */
    var pil = document.createElement('span');
    pil.className = 'nv-toggle-wrap nv-toggle-wrap--desk';
    var grupo = document.createElement('span');
    grupo.className = 'nv-toggle-group';

    var mkChip = function (texto, url, activo) {
      var c = document.createElement('a');
      c.href = url;
      c.className = 'nv-toggle' + (activo ? ' nv-toggle--active' : '');
      c.textContent = texto;
      if (activo) c.setAttribute('aria-current', 'true');
      else c.setAttribute('aria-label', 'Cambiar a ' + texto);
      return c;
    };
    grupo.appendChild(mkChip('Mujer', '/', !isMens));
    grupo.appendChild(mkChip('Hombre', '/pages/mens', isMens));
    pil.appendChild(grupo);

    var actions = document.querySelector('header-actions');
    if (actions) {
      /* Mobile switch DENTRO de header-actions (no flotante, no como hermano).
         Así hereda el grid-area "actions" del header y queda en la misma fila
         que el carrito en mobile. Insertamos al principio (antes de account/cart). */
      actions.insertBefore(a, actions.firstChild);
      actions.insertBefore(pil, actions.firstChild);
    } else {
      /* Fallback si header-actions no existe (edge case): meterlo al body */
      document.body.appendChild(a);
    }
  }

  function init() {
    tagAnchorSections();
    setupActiveLinkTracking();
    setupSmoothScroll();
    injectMobileUniverseSwitch();
    scrollToHashOnLoad();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-tag si Shopify re-renderiza secciones (theme editor live edit) */
  document.addEventListener('shopify:section:load', tagAnchorSections);
})();
